import React, { useState, useEffect } from "react";
import {
  Flex,
  Button,
  IconButton,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  Heading,
  useDisclosure,
  Icon,
} from "@chakra-ui/react";
import {
  textSecondary,
  textPrimary,
  white,
  buttonBlue,
  newBorder,
  backgroundLight,
  primaryAlt,
} from "../../../../utils/colors";
import { FaXmark } from "react-icons/fa6";
import { useTranslation } from "react-i18next";
// import FormControlAddressState from "../../../../components/input/FormControlAddressState";
import FormControlStatus from "../../../../components/input/FormControlStatus";
import FormControlRangePicker from "../../../../components/input/FormControlRangePicker";
import FormControlDatePickerRangeDouble from "../../../../components/input/FormControlDatePickerRangeDouble";
import { parseISO } from "date-fns";
import { TbAdjustmentsHorizontal } from "react-icons/tb";
import useThemeColors from "../../../../hooks/useThemeColors";
import { motion } from "framer-motion";
import FormControlEmployee from "../../../../components/input/FormControlEmployee";
import DrawerNew from "../../../../components/menu/DrawerNew";
import useIsMobile from "../../../../hooks/useIsMobile";

const TreatmentPlansFilterPopover = ({
  onFilterApply,
  isFilterActive,
  setIsFilterActive,
  filterStatusOptions,
  savedFiltersKey,
  resetFilter, // New prop
  onResetComplete, // Callback when reset is handled
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { whiteMode, newBorderMode } = useThemeColors();
  const [originalFilterState, setOriginalFilterState] = useState(null);
  const isMobile = useIsMobile();

  const [filterState, setFilterState] = useState({
    employeeId: [],
    status: [],
    startDate: "",
    endDate: "",
    minPrice: "",
    maxPrice: "",
    creatorEmployeeId: [],
    coordinatorId: [],
  });

  useEffect(() => {
    if (resetFilter) {
      // If the resetFilter prop is true, reset the local state
      const resetState = {
        employeeId: [],
        status: [],
        startDate: "",
        endDate: "",
        minPrice: "",
        maxPrice: "",
        creatorEmployeeId: [],
        coordinatorId: [],
      };
      setFilterState(resetState);

      // Call the onResetComplete callback to indicate reset is handled
      if (onResetComplete) {
        onResetComplete();
      }
    }
  }, [resetFilter, onResetComplete]);

  const onOpenPopover = () => {
    setOriginalFilterState({ ...filterState }); // Save the current state when popover opens
    onOpen(); // Call Chakra's `onOpen` to actually open the popover
  };

  const applyFilters = () => {
    const formattedFilterState = {
      ...filterState,
      status: Array.isArray(filterState.status)
        ? filterState.status.join(",")
        : "",
      employeeId: Array.isArray(filterState.employeeId)
        ? filterState.employeeId.join(",")
        : "",
      creatorEmployeeId: Array.isArray(filterState.creatorEmployeeId)
        ? filterState.creatorEmployeeId.join(",")
        : "",
      coordinatorId: Array.isArray(filterState.coordinatorId)
        ? filterState.coordinatorId.join(",")
        : "",
    };

    localStorage.setItem(savedFiltersKey, JSON.stringify(formattedFilterState)); // Save to localStorage only on Apply
    onFilterApply(formattedFilterState);
    setOriginalFilterState({ ...filterState }); // Update original to the newly applied filter
    onClose();
  };

  const handleAgeChange = (values) => {
    setFilterState({
      ...filterState,
      minPrice: values[0],
      maxPrice: values[1],
    });
  };

  const handleDateRangeChange = (start, end) => {
    setFilterState({ ...filterState, startDate: start, endDate: end });
  };

  const handleStatusChange = (selectedOptions) => {
    const selectedValues = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];

    console.log("Selected values after change:", selectedValues);

    setFilterState((prevState) => ({
      ...prevState,
      status: selectedValues,
    }));

    // Removed localStorage update here
  };

  const handleEmployeeIdChange = (selectedOptions) => {
    const selectedValues = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setFilterState({
      ...filterState,
      employeeId: selectedValues,
    });
  };

  const handleCreatorEmployeeIdChange = (selectedOptions) => {
    const selectedValues = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setFilterState({
      ...filterState,
      creatorEmployeeId: selectedValues,
    });
  };

  const handleCoordinatorIdChange = (selectedOptions) => {
    const selectedValues = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setFilterState({
      ...filterState,
      coordinatorId: selectedValues,
    });
  };

  const handlePopoverClose = () => {
    // Restore original state if closing without applying
    if (originalFilterState) setFilterState(originalFilterState);
    onClose();
  };

  const clearFilters = () => {
    console.log("RESET IN FILTERPOPOVER PRESSED");
    const resetState = {
      minPrice: null,
      maxPrice: null,
      startDate: "",
      endDate: "",
      status: [],
      employeeId: [],
    };
    setFilterState(resetState);
    onFilterApply(resetState);
    setIsFilterActive(false);
    localStorage.removeItem(savedFiltersKey);
    onClose();
  };
  // Update clearFilters to reset and update localStorage

  const { t } = useTranslation();

  const handleClose = () => {
    onClose();
  };

  useEffect(() => {
    const savedFiltersStr = localStorage.getItem(savedFiltersKey);
    if (savedFiltersStr) {
      let savedFilters = JSON.parse(savedFiltersStr);
      if (typeof savedFilters.status === "string") {
        savedFilters.status = savedFilters.status.split(",");
      }
      if (typeof savedFilters.employeeId === "string") {
        savedFilters.employeeId = savedFilters.employeeId.split(",");
      }
      if (typeof savedFilters.creatorEmployeeId === "string") {
        savedFilters.creatorEmployeeId =
          savedFilters.creatorEmployeeId.split(",");
      }
      if (typeof savedFilters.coordinatorId === "string") {
        savedFilters.coordinatorId = savedFilters.coordinatorId.split(",");
      }

      savedFilters.startDate = savedFilters.startDate
        ? parseISO(savedFilters.startDate)
        : "";
      savedFilters.endDate = savedFilters.endDate
        ? parseISO(savedFilters.endDate)
        : "";
      setFilterState(savedFilters);
    }
  }, [savedFiltersKey]);

  useEffect(() => {
    const mainContent = document.getElementById("main-content");

    if (isOpen) {
      if (mainContent) {
        mainContent.style.overflow = "hidden";
      }
    } else {
      if (mainContent) {
        mainContent.style.overflow = "";
      }
    }

    // Cleanup when the component unmounts or `isOpen` changes
    return () => {
      if (mainContent) {
        mainContent.style.overflow = "";
      }
    };
  }, [isOpen]);

  // CUSTOM
  const applyDisabled =
    filterState.minPrice === "" &&
    filterState.maxPrice === "" &&
    filterState.startDate === "" &&
    filterState.endDate === "" &&
    filterState.status.length === 0 &&
    filterState.employeeId.length === 0 &&
    filterState.creatorEmployeeId.length === 0 &&
    filterState.coordinatorId.length === 0;

  // LOGS
  // console.log("filterStatusOptions", filterStatusOptions);

  return (
    <>
      {!isMobile ? (
        <Popover
          isOpen={isOpen}
          onClose={handlePopoverClose}
          placement={"bottom-end"}
        >
          <PopoverTrigger position="relative">
            <Button
              border={`1px solid ${newBorderMode}`}
              borderRadius="10rem"
              size="md"
              fontSize="md"
              fontWeight="500"
              color={isFilterActive ? white : textSecondary}
              onClick={onOpenPopover}
              zIndex="0"
              bg={isFilterActive ? primaryAlt : whiteMode}
              align="center"
              transition="0.2s all"
              _hover={{
                bg: isFilterActive ? primaryAlt : primaryAlt,
                color: white,
                border: `1px solid ${buttonBlue}`,
              }}
              mr={1}
              _focus={{
                boxShadow: "none",
              }}
            >
              <Icon as={TbAdjustmentsHorizontal} fontSize="1rem" />
            </Button>
          </PopoverTrigger>
          {isOpen && (
            <PopoverContent
              border="none"
              boxShadow="1px 1px 6px rgba(0, 0, 0, 0.3)"
              borderRadius="1.5rem"
              bg={white}
              w="460px"
              as={motion.div}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { duration: 0.2 } }}
              exit={{ opacity: 0 }}
              _focus={{
                outline: "none",
                boxShadow: "1px 1px 6px rgba(0, 0, 0, 0.3)",
              }}
            >
              {/* <PopoverArrow /> */}
              <PopoverHeader
                borderTopLeftRadius="1rem"
                borderTopRightRadius="1rem"
                borderBottom={`1px solid ${newBorder}`}
                p="1rem 1.5rem"
              >
                <Flex w="100%" justify="space-between" align="center">
                  <Heading fontSize="1rem" fontWeight="600" color={textPrimary}>
                    {t("filter.filter")}
                  </Heading>

                  <IconButton
                    size="sm"
                    bg={backgroundLight}
                    color={textSecondary}
                    onClick={handleClose}
                    borderRadius="10rem"
                    _hover={{ bg: primaryAlt, color: white }}
                  >
                    <Icon as={FaXmark} />
                  </IconButton>
                </Flex>
              </PopoverHeader>
              <PopoverBody p="0">
                <Flex direction="column" p="1rem 1.5rem 0rem" gap="0.75rem">
                  <FormControlDatePickerRangeDouble
                    type="date"
                    label={t("form.regDate")}
                    placeholder={t("placeholder.endDate")}
                    onChange={(start, end) => handleDateRangeChange(start, end)}
                    startDate={filterState.startDate}
                    endDate={filterState.endDate}
                    maxDate={new Date()} // This sets the maximum date to today.
                    w="50%"
                    isSmall
                    mb="0"
                  />
                  <FormControlRangePicker
                    isSmall
                    label={t("filter.treatmentPlanPrice")}
                    min={filterState.minPrice}
                    max={filterState.maxPrice}
                    minFilter={50}
                    maxFilter={50000}
                    step={50}
                    setMin={handleAgeChange}
                    setMax={handleAgeChange}
                    mb="1rem"
                  />
                  <FormControlStatus
                    label={t("filter.treatmentPlanStatus")}
                    value={filterState.status}
                    placeholder={t("placeholder.treatmentPlanStatus")}
                    options={filterStatusOptions}
                    onChange={handleStatusChange}
                    w="100%"
                    isSmall
                    isMulti
                    mb="0"
                  />

                  {/* <FormControlEmployee
                label={t("form.employeeInService")}
                value={filterState.employeeId}
                placeholder={t("placeholder.employeeInService")}
                onChange={handleEmployeeIdChange}
                isMulti
                isSmall
              /> */}

                  <FormControlEmployee
                    label={t("filter.creatorEmployee")}
                    value={filterState.creatorEmployeeId}
                    placeholder={t("placeholder.creatorEmployee")}
                    onChange={handleCreatorEmployeeIdChange}
                    isMulti
                    isSmall
                    mb="0"
                  />

                  <FormControlEmployee
                    label={t("filter.coordinator")}
                    value={filterState.coordinatorId}
                    placeholder={t("placeholder.coordinator")}
                    onChange={handleCoordinatorIdChange}
                    isMulti
                    isSmall
                    mb="0"
                  />

                  {/* <FormControlAddressState
                label={t("form.addressState")}
                value={filterState.state}
                placeholder={t("placeholder.addressState")}
                onChange={handleStateChange}
                w="100%"
                isSmall
                isMulti
                mb="0"
              /> */}
                </Flex>
              </PopoverBody>
              <PopoverFooter p="1.5rem 1.5rem 1.5rem" border="none">
                <Flex w="100%" align="center" justify="center" gap="1rem">
                  <Button
                    // variant="ghost"
                    size="md"
                    bg={backgroundLight}
                    fontSize="sm"
                    color={textSecondary}
                    borderRadius="10rem"
                    onClick={clearFilters}
                    // isDisabled={!isFilterActive}
                    isDisabled={applyDisabled}
                  >
                    {t("filter.clearFilter")}
                  </Button>
                  <Button
                    size="md"
                    fontSize="sm"
                    fontWeight="600"
                    bg={textPrimary}
                    color={white}
                    borderRadius="10rem"
                    p="1rem 1.5rem"
                    onClick={applyFilters}
                    _hover={{
                      bg: primaryAlt,
                    }}
                    isDisabled={applyDisabled}
                  >
                    {t("button.filterApply")}
                  </Button>
                </Flex>
              </PopoverFooter>
            </PopoverContent>
          )}
        </Popover>
      ) : (
        <>
          <Flex position="relative">
            <Button
              border={`1px solid ${newBorderMode}`}
              borderRadius="10rem"
              size="md"
              fontSize="md"
              fontWeight="500"
              color={isFilterActive ? white : textSecondary}
              onClick={onOpenPopover}
              zIndex="0"
              bg={isFilterActive ? primaryAlt : whiteMode}
              align="center"
              transition="0.2s all"
              _hover={{
                bg: isFilterActive ? primaryAlt : primaryAlt,
                color: white,
                border: `1px solid ${buttonBlue}`,
              }}
              mr={1}
              _focus={{
                boxShadow: "none",
              }}
            >
              <Icon as={TbAdjustmentsHorizontal} fontSize="1rem" />
            </Button>
          </Flex>

          <DrawerNew
            isOpen={isOpen}
            onClose={handlePopoverClose}
            title={t("treatmentPlan.filter")}
            size="full"
          >
            {/* <PopoverArrow /> */}
            <Flex
              borderTopLeftRadius="1rem"
              borderTopRightRadius="1rem"
              borderBottom={`1px solid ${newBorder}`}
              p="1rem 1.5rem"
            >
              <Flex w="100%" justify="space-between" align="center">
                <Heading fontSize="1rem" fontWeight="600" color={textPrimary}>
                  {t("filter.filter")}
                </Heading>

                <IconButton
                  size="sm"
                  bg={backgroundLight}
                  color={textSecondary}
                  onClick={handleClose}
                  borderRadius="10rem"
                  _hover={{ bg: primaryAlt, color: white }}
                >
                  <Icon as={FaXmark} />
                </IconButton>
              </Flex>
            </Flex>
            <Flex p="0">
              <Flex direction="column" p="1rem 1.5rem 0rem" gap="0.75rem">
                <FormControlDatePickerRangeDouble
                  type="date"
                  label={t("form.regDate")}
                  placeholder={t("placeholder.endDate")}
                  onChange={(start, end) => handleDateRangeChange(start, end)}
                  startDate={filterState.startDate}
                  endDate={filterState.endDate}
                  maxDate={new Date()} // This sets the maximum date to today.
                  w="50%"
                  isSmall
                  mb="0"
                />
                <FormControlRangePicker
                  isSmall
                  label={t("filter.treatmentPlanPrice")}
                  min={filterState.minPrice}
                  max={filterState.maxPrice}
                  minFilter={50}
                  maxFilter={50000}
                  step={50}
                  setMin={handleAgeChange}
                  setMax={handleAgeChange}
                  mb="1rem"
                />
                <FormControlStatus
                  label={t("filter.treatmentPlanStatus")}
                  value={filterState.status}
                  placeholder={t("placeholder.treatmentPlanStatus")}
                  options={filterStatusOptions}
                  onChange={handleStatusChange}
                  w="100%"
                  isSmall
                  isMulti
                  mb="0"
                />

                {/* <FormControlEmployee
                label={t("form.employeeInService")}
                value={filterState.employeeId}
                placeholder={t("placeholder.employeeInService")}
                onChange={handleEmployeeIdChange}
                isMulti
                isSmall
              /> */}

                <FormControlEmployee
                  label={t("filter.creatorEmployee")}
                  value={filterState.creatorEmployeeId}
                  placeholder={t("placeholder.creatorEmployee")}
                  onChange={handleCreatorEmployeeIdChange}
                  isMulti
                  isSmall
                  mb="0"
                />

                <FormControlEmployee
                  label={t("filter.coordinator")}
                  value={filterState.coordinatorId}
                  placeholder={t("placeholder.coordinator")}
                  onChange={handleCoordinatorIdChange}
                  isMulti
                  isSmall
                  mb="0"
                />

                {/* <FormControlAddressState
                label={t("form.addressState")}
                value={filterState.state}
                placeholder={t("placeholder.addressState")}
                onChange={handleStateChange}
                w="100%"
                isSmall
                isMulti
                mb="0"
              /> */}
              </Flex>
            </Flex>
            <Flex p="1.5rem 1.5rem 1.5rem" border="none">
              <Flex w="100%" align="center" justify="center" gap="1rem">
                <Button
                  // variant="ghost"
                  size="md"
                  bg={backgroundLight}
                  fontSize="sm"
                  color={textSecondary}
                  borderRadius="10rem"
                  onClick={clearFilters}
                  // isDisabled={!isFilterActive}
                  isDisabled={applyDisabled}
                >
                  {t("filter.clearFilter")}
                </Button>
                <Button
                  size="md"
                  fontSize="sm"
                  fontWeight="600"
                  bg={textPrimary}
                  color={white}
                  borderRadius="10rem"
                  p="1rem 1.5rem"
                  onClick={applyFilters}
                  _hover={{
                    bg: primaryAlt,
                  }}
                  isDisabled={applyDisabled}
                >
                  {t("button.filterApply")}
                </Button>
              </Flex>
            </Flex>
          </DrawerNew>
        </>
      )}
    </>
  );
};

export default TreatmentPlansFilterPopover;
